// extracted by mini-css-extract-plugin
module.exports = {"executivesContainer":"executives_executivesContainer__XTgNp"};